export * from './queries/use-district-list.query';
export * from './queries/use-industry-children.query';
export * from './queries/use-industry-roots.query';
export * from './queries/use-language-get-by-id.query';
export * from './queries/use-language-list.query';
export * from './queries/use-occupation-children.query';
export * from './queries/use-occupation-roots.query';
export * from './queries/use-province-list.query';
